import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.mypage/view.scss */
/* src/app/page.mypage/view.scss: no such file or directory */`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public saving: boolean = false;
    public hasPassword: boolean = true;

    public passwordForm: any = {
        current_password: '',
        new_password: '',
        confirm_password: ''
    };
    public changingPassword: boolean = false;

    // 탭
    public tab: string = 'profile';

    // 접속 이력
    public accessLogs: any[] = [];
    public accessLogTotal: number = 0;
    public accessLogPage: number = 1;
    public accessLogDump: number = 10;
    public loadingLogs: boolean = false;

    // 세션 관리
    public sessions: any[] = [];
    public currentToken: string = '';
    public loadingSessions: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
        await this.service.render();
    }

    public async selectTab(tab: string) {
        this.tab = tab;
        if (tab === 'security') {
            await this.loadAccessLogs();
            await this.loadSessions();
        }
        await this.service.render();
    }

    public async load() {
        const { code, data } = await wiz.call("get");
        if (code === 200) {
            this.user = data.user;
            this.hasPassword = data.has_password;
        }
        await this.service.render();
    }

    // ---- 접속 이력 ----
    public async loadAccessLogs(page: number = 1) {
        this.loadingLogs = true;
        this.accessLogPage = page;
        await this.service.render();

        const { code, data } = await wiz.call("access_logs", {
            page: this.accessLogPage,
            dump: this.accessLogDump
        });

        if (code === 200) {
            this.accessLogs = data.rows || [];
            this.accessLogTotal = data.total || 0;
        }
        this.loadingLogs = false;
        await this.service.render();
    }

    public get accessLogTotalPages(): number {
        return Math.ceil(this.accessLogTotal / this.accessLogDump);
    }

    public get accessLogPages(): number[] {
        const total = this.accessLogTotalPages;
        const current = this.accessLogPage;
        const pages: number[] = [];
        let start = Math.max(1, current - 2);
        let end = Math.min(total, start + 4);
        start = Math.max(1, end - 4);
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    }

    public parseUserAgent(ua: string): string {
        if (!ua) return '-';
        let browser = 'Unknown';
        let os = 'Unknown';

        if (ua.includes('Firefox')) browser = 'Firefox';
        else if (ua.includes('Edg/')) browser = 'Edge';
        else if (ua.includes('Chrome')) browser = 'Chrome';
        else if (ua.includes('Safari')) browser = 'Safari';
        else if (ua.includes('curl')) browser = 'curl';

        if (ua.includes('Windows')) os = 'Windows';
        else if (ua.includes('Mac OS')) os = 'macOS';
        else if (ua.includes('Linux')) os = 'Linux';
        else if (ua.includes('Android')) os = 'Android';
        else if (ua.includes('iOS') || ua.includes('iPhone')) os = 'iOS';

        return `${browser} / ${os}`;
    }

    public actionLabel(action: string): string {
        const labels: any = {
            'login': '이메일 로그인',
            'saml_login': 'SSO 로그인'
        };
        return labels[action] || action;
    }

    // ---- 세션 관리 ----
    public async loadSessions() {
        this.loadingSessions = true;
        await this.service.render();

        const { code, data } = await wiz.call("sessions");
        if (code === 200) {
            this.sessions = data.sessions || [];
            this.currentToken = data.current_token || '';
        }
        this.loadingSessions = false;
        await this.service.render();
    }

    public async revokeSession(token: string) {
        const res = await this.service.modal.show({
            title: '세션 종료',
            message: '이 세션을 종료하시겠습니까?',
            action: '종료',
            status: 'error'
        });
        if (!res) return;

        const { code } = await wiz.call("revoke_session", { session_token: token });
        if (code === 200) {
            await this.service.modal.success("세션이 종료되었습니다.");
            await this.loadSessions();
        }
    }

    public async revokeAllSessions() {
        const res = await this.service.modal.show({
            title: '다른 세션 모두 종료',
            message: '현재 세션을 제외한 모든 세션을 종료하시겠습니까?',
            action: '모두 종료',
            status: 'error'
        });
        if (!res) return;

        const { code } = await wiz.call("revoke_all_sessions");
        if (code === 200) {
            await this.service.modal.success("다른 세션이 모두 종료되었습니다.");
            await this.loadSessions();
        }
    }

    // ---- 프로필 ----
    public async updateProfile() {
        if (!this.user.name) {
            await this.service.modal.error("이름을 입력해주세요.");
            return;
        }
        this.saving = true;
        await this.service.render();

        const { code, data } = await wiz.call("update_profile", {
            name: this.user.name,
            mobile: this.user.mobile || ''
        });

        await this.service.sleep(500);
        this.saving = false;

        if (code === 200) {
            await this.service.modal.success("프로필이 업데이트되었습니다.");
        } else {
            await this.service.modal.error(data || "업데이트에 실패했습니다.");
        }
        await this.service.render();
    }

    // ---- 비밀번호 ----
    public async changePassword() {
        const { current_password, new_password, confirm_password } = this.passwordForm;

        if (this.hasPassword && !current_password) {
            await this.service.modal.error("현재 비밀번호를 입력해주세요.");
            return;
        }
        if (!new_password) {
            await this.service.modal.error("새 비밀번호를 입력해주세요.");
            return;
        }
        if (new_password.length < 8) {
            await this.service.modal.error("새 비밀번호는 8자 이상이어야 합니다.");
            return;
        }
        if (new_password !== confirm_password) {
            await this.service.modal.error("새 비밀번호가 일치하지 않습니다.");
            return;
        }

        this.changingPassword = true;
        await this.service.render();

        let params: any = {
            new_password: this.service.auth.hash(new_password)
        };

        if (this.hasPassword) {
            params.current_password = this.service.auth.hash(current_password);
        } else {
            params.is_initial = true;
        }

        const { code, data } = await wiz.call("change_password", params);

        await this.service.sleep(500);
        this.changingPassword = false;

        if (code === 200) {
            await this.service.modal.success(data || "비밀번호가 설정되었습니다.");
            this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
            this.hasPassword = true;
        } else {
            await this.service.modal.error(data || "비밀번호 변경에 실패했습니다.");
        }
        await this.service.render();
    }
}

export default PageMypageComponent;